var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

const getLighterShade = (hexValue, percent = 90) => {
  if (!hexValue) return '';
  // Remove # if present
  const hex = hexValue.replace('#', '');

  // Convert to RGB
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Mix with white (255,255,255)
  const factor = percent / 100;
  const newR = Math.round(r + (255 - r) * factor);
  const newG = Math.round(g + (255 - g) * factor);
  const newB = Math.round(b + (255 - b) * factor);

  // Convert back to hex
  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
};

const DisplayPill = ({
  children,
  color = '#111928',
  className




}) => {
  const bgColor = getLighterShade(color);
  const style = { backgroundColor: bgColor, color };
  return (/*#__PURE__*/
    _jsx("span", {
      className: `${className !== null && className !== void 0 ? className : 'px-2.5 py-1 rounded-md text-xs'}`,
      style: style,
      "data-testid": "pill-comp" }, void 0,

    children
    ));

};

export { DisplayPill };